import Image from 'next/image';

const ImageContainer = ({ imageMobile, children }) => (
  <div className="relative">
    <div className="md:hidden relative">
      <Image
        src={imageMobile?.image}
        alt={imageMobile?.alt}
        width={imageMobile?.width || 0}
        height={imageMobile?.height || 0}
        sizes="100vw"
        className="w-full h-auto"
      />
    </div>
    <div className="hidden md:block">{children}</div>
  </div>
);

export default ImageContainer;
